<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="配置可选角色"
        :close-on-press-escape="false"
        width="600px"
        append-to-body
        :before-close="handleClose">
        <el-form ref="form" :rules="rules" :model="formItem" label-width="120px" class="pr40">
            <el-form-item label="角色：" prop="optional_role">
                <ESelect v-model="formItem.optional_role" multiple :disabled="isView" class="full-w" placeholder="请选择角色">
                    <el-option
                        v-for="item in roleList"
                        :key="item.role_id"
                        :label="item.role_name"
                        :value="item.role_id">
                        {{item.role_name}}
                    </el-option>
                </ESelect>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer tac" v-if="isView">
            <el-button type="default" @click="handleClose" class="action-btn mr20">关闭</el-button>
        </div>
        <div v-else slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "ConfigOptionalRoleModal",
        components:{

        },
        props:{
            page:{
                type: Object,
                required: true
            },
            isView:{
                type: Boolean,
                required:true,
            },
        },
        data() {
            return {
                dialogVisible: false,
                formItem: {
                    optional_role: [],
                },
                rules:{
                    optional_role:[
                        // { type: 'array', required: true, message: '请选择角色', trigger: 'change' },
                    ]
                }

            }
        },
        computed: {
            ...mapState({
                roleList: state => state.roleData.roleList,
            }),
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            showModal() {
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    let optionalRole = this.page.optional_role_val;
                    if(optionalRole&&optionalRole.length>0){
                        this.formItem.optional_role = optionalRole.map(item=>item);
                    }
                })
            },
            resetForm() {
                console.log('resetForm');
                this.formItem.optional_role = [];
            },
            handleSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$emit('save-roles',this.page,this.formItem);
                        this.handleClose();

                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .action-btn {
        width: 120px;
    }
</style>
